function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M22.355 1.063l.043.02c.004 0 .007.003.011.004.105.047.2.112.283.191l.015.015.015.015c.078.081.142.175.19.277l.008.022c.087.197.11.427.043.662l-.012.042-.007.02-7 20c-.3.854-1.49.903-1.858.075l-3.844-8.648-8.648-3.844c-.828-.368-.78-1.559.076-1.858l20-7 .019-.007.041-.012-.06.02a.98.98 0 01.145-.04l.017-.003a.968.968 0 01.523.05zm-2.747 4.743l-7.416 7.416 2.697 6.067 4.719-13.483zm-1.415-1.415L4.711 9.111l6.066 2.696 7.416-7.416z",
    fill: props.color,
    fillRule: "evenodd"
  }));
}
export default SvgIconSend;